export default __webpack_public_path__ + "static/media/logo.5bc9193a.png";